import type { RouteLocationNormalizedLoaded } from 'vue-router'
import type { Router } from 'vue-router'

/**
 * Heuristic for tests / diagnostics only: whether the path looks like passport v2 runtime.
 */
export function isPassportRuntimeV2LikeRoute(route: RouteLocationNormalizedLoaded): boolean {
  const n = String(route.name ?? '')
  if (/passport.*v2|v2.*passport|PassportRuntime|ElementsPassportV2/i.test(n)) return true
  const p = route.path ?? ''
  if (p.includes('passport-v2') || p.includes('passport_v2')) return true
  return false
}

/**
 * Резолвит переход в паспорт дочерней строки: зеркалит текущий именованный маршрут, если в его path
 * есть слот `:invent_object_id`; иначе (например, create-v2 без параметра элемента — лишний param
 * отбрасывается и ссылка вырождается в текущий URL) использует явный маршрут
 * `object.inventory.elements.passport-v2`.
 */
export function resolveChildPassportLocation(
  route: RouteLocationNormalizedLoaded,
  router: Router,
  childListItemId: number,
) {
  const idStr = String(childListItemId)
  const hasElementParam = route.matched.some((record) =>
    record.path.includes(':invent_object_id'),
  )
  if (route.name != null && hasElementParam) {
    return router.resolve({
      name: route.name,
      params: { ...route.params, invent_object_id: idStr },
      query: route.query,
    })
  }
  return router.resolve({
    name: 'object.inventory.elements.passport-v2',
    params: {
      ...route.params,
      tab_inventory: 'elements',
      invent_object_id: idStr,
    },
    query: route.query,
  })
}
